'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isStampDescriptor = isStampDescriptor;
exports.default = parseDesc;

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _stampUtils = require('stamp-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var descriptorNames = ['methods', 'properties', 'deepProperties', 'propertyDescriptors', 'staticProperties', 'deepStaticProperties', 'staticPropertyDescriptors', 'initializers', 'configuration'];

function isStampDescriptor(desc) {
  if ((0, _stampUtils.isDescriptor)(desc) && Object.keys(desc).some(function (name) {
    return descriptorNames.includes(name);
  })) {
    return true;
  } else if ((0, _isEmpty2.default)(desc)) {
    return true;
  }
  return false;
}

/**
 * Create a stamp spec compliant desc object.
 *
 * (desc?: Stamp | ReactDesc | SpecDesc) => SpecDesc
 */
function parseDesc() {
  var desc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if ((0, _stampUtils.isStamp)(desc)) {
    return desc.compose;
  } else if (isStampDescriptor(desc)) {
    return desc;
  }

  var displayName = desc.displayName,
      init = desc.init,
      state = desc.state,
      statics = desc.statics,
      contextTypes = desc.contextTypes,
      childContextTypes = desc.childContextTypes,
      propTypes = desc.propTypes,
      defaultProps = desc.defaultProps,
      methods = _objectWithoutProperties(desc, ['displayName', 'init', 'state', 'statics', 'contextTypes', 'childContextTypes', 'propTypes', 'defaultProps']);

  var parsedDesc = {};

  displayName && (parsedDesc.staticProperties = { displayName: displayName });
  init && (parsedDesc.initializers = [init]);
  state && (parsedDesc.deepProperties = { state: state });
  methods && (parsedDesc.methods = methods);
  parsedDesc.deepStaticProperties = _extends({}, statics);

  (0, _forEach2.default)({ contextTypes: contextTypes, childContextTypes: childContextTypes, propTypes: propTypes, defaultProps: defaultProps }, function (val, key) {
    return val && (parsedDesc.deepStaticProperties[key] = val);
  });

  return parsedDesc;
}